import {
  updateApartment,
  updateCity,
  updatePIFirstName,
  updatePILastName,
  updatePostalCode,
  updateStateOrProvince,
  updateStreetAddress,
  updateTier3PACode,
  updateTier3Vin
} from '../redux/app-state-slice';

const loadCustomerDataFromEcomInput = (prequalInput, dispatch) => {
  prequalInput.split('^').forEach((item) => {
    const [key, value] = item.split('~');
    switch (key) {
      case 'vin':
        dispatch(updateTier3Vin(value));
        break;
      case 'dealerid':
        dispatch(updateTier3PACode(value));
        break;
      case 'firstName':
        dispatch(updatePIFirstName(value));
        break;
      case 'lastName':
        dispatch(updatePILastName(value));
        break;
      case 'streetAddress':
        dispatch(updateStreetAddress(value));
        break;
      case 'apartment':
        dispatch(updateApartment(value));
        break;
      case 'city':
        dispatch(updateCity(value));
        break;
      case 'state':
        dispatch(updateStateOrProvince(value));
        break;
      case 'zipCode':
        dispatch(updatePostalCode(value));
        break;
      default:
        break;
    }
  });
};

const loadCustomerDataFromInput = (source, prequalInput, customerData, dispatch) => {
  const sourceEnv = source.split('-')[0];
  if (sourceEnv === 'DCF') {
    const tier3PACode = extractValueFromInputString(prequalInput, 'dealerid');
    if (tier3PACode) {
      dispatch(updateTier3PACode(tier3PACode));
    }
    const tier3Vin = extractValueFromInputString(prequalInput, 'vin');
    if (tier3Vin) {
      dispatch(updateTier3Vin(tier3Vin));
    }
  }
  if (sourceEnv === 'ECOM') {
    loadCustomerDataFromEcomInput(prequalInput, dispatch);
  }
};

export function extractValueFromInputString(prequalInput, key) {
  let inputValue = null;
  if (prequalInput) {
    const inputValues = prequalInput.split('^');
    if (inputValues) {
      inputValues.forEach((item) => {
        const inputArray = item.split('~');
        if (inputArray && inputArray[0] === key && inputArray.length > 1) {
          inputValue = inputArray[1];
        }
      });
    }
  }
  return inputValue;
}
export default loadCustomerDataFromInput;
